"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionBankItem = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCss_1 = __importDefault(require("@opsbase/web-css/useCss"));
const GrabIcon_1 = __importDefault(require("@opsbase/web-icons/icons/GrabIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Highlight_1 = __importDefault(require("@opsbase/web-ui/Highlight"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const QuestionTypeIcon_1 = __importDefault(require("../QuestionTypeIcon"));
const makeMyClasses = (highlight, count) => ({
    root: {
        background: lib_palette_1.default.White.main,
        width: '100%',
        padding: '8px 8px',
        paddingLeft: 0,
        margin: 2,
        zIndex: 4,
        cursor: 'grab',
        borderRadius: 4,
        border: `1px solid transparent`,
        transition: 'border 0.3s, box-shadow 0.3s',
        '&:hover': {
            border: `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
            boxShadow: `0 0 12px -4px ${lib_palette_1.default.BlackCoral.main}`,
        },
        '& .selectionContainer': {
            overflow: 'hidden',
        },
        '& .lines': {
            display: 'none',
            position: 'absolute',
            zIndex: 0,
            borderBottom: `2px solid ${lib_palette_1.default.LavendarGrey.main}`,
            width: 50,
            height: 49,
            top: -24,
        },
        '& .expander': {
            display: 'none',
            position: 'relative',
            width: 36,
            height: 48,
        },
        '& .iconBit': {
            display: 'none',
            paddingRight: 13,
            borderRight: `1px solid ${lib_palette_1.default.GoodOldBlue.main}`,
        },
        '& .countBit': {
            display: count > 0 ? undefined : 'none',
            minWidth: 20,
            maxWidth: 20,
            height: 20,
            fontSize: 11,
            lineHeight: '20px',
            background: lib_palette_1.default.GoodGreen.main,
            color: lib_palette_1.default.GoodGreen.contrastText,
            borderRadius: '50%',
            textAlign: 'center',
        },
        '& .textBit': {
            flex: 1,
            color: highlight ? lib_palette_1.default.primary.main : undefined,
        },
        // DRAG MODE
        '&.pickerDrag': {
            '& .countBit': {
                display: 'none !important',
            },
            '& .textBit': {
                color: 'unset',
            },
        },
        // GHOST MODE
        '&.questionTreeGhost': {
            background: 'transparent !important',
            padding: '2px 2px 2px 0px',
            '& .selectionContainer': {
                borderRadius: 4,
                padding: '0 8px 0 8px !important',
            },
            '& .textBit': {
                color: 'unset',
                margin: '11px 0',
            },
            '& .spacer': {
                minWidth: 88,
                maxWidth: 88,
                width: 88,
            },
            '& .dragger': {
                display: 'none !important',
            },
            '& .iconBit': {
                display: 'unset !important',
            },
            '& .expander': {
                display: 'unset !important',
            },
            '& .lines': {
                display: 'unset !important',
            },
            '& .countBit': {
                display: 'none !important',
            },
        },
    },
});
function QuestionBankItem(props) {
    const { title, highlight = false, count = 0, keywordHighlight } = props;
    const myCss = (0, useCss_1.default)(makeMyClasses, [highlight, count]);
    return (react_1.default.createElement("div", { className: myCss.root + ' dragHandle' },
        react_1.default.createElement(Horizontal_1.default, null,
            react_1.default.createElement(Pane_1.default, { classes: { root: 'expander' } },
                react_1.default.createElement("div", { className: 'lines' })),
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(GrabIcon_1.default, { color: lib_palette_1.default.PastelBlue, className: 'dragger' })),
            react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true, classes: { root: 'selectionContainer' } },
                react_1.default.createElement(Pane_1.default, { classes: { root: 'iconBit' } },
                    react_1.default.createElement(QuestionTypeIcon_1.default, { type: FormQuestionType_1.default.QUESTIONSET })),
                react_1.default.createElement(Highlight_1.default, { className: 'textBit', search: keywordHighlight }, title),
                react_1.default.createElement(Text_1.default, { className: 'countBit' }, count)),
            react_1.default.createElement(Pane_1.default, { classes: { root: 'spacer' } }))));
}
exports.QuestionBankItem = QuestionBankItem;
exports.default = QuestionBankItem;
